import React from "react";
import { TableBodyProps } from "./table.types";

export const TableBody = ({
  children,
  className,
  ...rest
}: TableBodyProps): React.ReactElement => {
  return (
    <tbody className={className} {...rest}>
      {children}
    </tbody>
  );
};

TableBody.displayName = "TableBody";
